import { createStyles, makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    avatarContainer: {
      cursor: "pointer",
    },
  })
);

export default useStyles;
